import { ProtectedRoute } from '@components/protectedRoute';
import { WorkloadProvider } from '@contexts/workload';
import { appRoutes } from '@utils/consts';

export const workloadRoutes = [
  {
    path: appRoutes.workload,
    lazy: async () => {
      const { Workload } = await import('@pages/workload');
      return {
        Component: () => (
          <ProtectedRoute>
            <WorkloadProvider>
              <Workload />
            </WorkloadProvider>
          </ProtectedRoute>
        ),
      };
    },
  },
];
